// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a52cef65","677":"8c384f16"}[chunkId] + ".chunk.js";
};